import React from 'react';
import { WorkspaceHero } from '../components/WorkspaceHero';
import { NovaSection } from '../components/nova/NovaSection';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// Exploration variant of the home page. Identical to Home, but the hero is
// reimagined as an animated Slack/Teams workspace where colleagues @mention
// Giga and Giga replies with finished work — a place to explore the
// "chat box as a real workspace" direction.
export function WorkspaceHome() {
  return <>
      <WorkspaceHero data-id="element-13249" data-mp="2nr7yrlw70ypk" />
      <NovaSection data-id="element-13250" data-mp="2nqokcf5r4sga" />
      <AudienceSwitch data-id="element-13251" data-mp="2nqg3kc6id2zt" />
      <LivesInSlack data-id="element-13252" data-mp="2nu3wpa81jne0" />
      <ComputerUse data-id="element-13253" data-mp="2rt2wyhituvz4" />
      <CapabilityGrid data-id="element-13254" data-mp="2rue3gp3nqhtx" />
      <NarrativeSection data-id="element-13255" data-mp="2ruw6q5oqlwbc" />
      <WallOfLove data-id="element-13256" data-mp="2rr00pfr306ly" />
      <GettingStartedSteps data-id="element-13257" data-mp="2dttipne6mbxs" />
      <PricingSection data-id="element-13258" data-mp="2dulht86zmrst" />
      <ClosingCTA data-id="element-13259" data-mp="2dv4qdyar03u6" />
    </>;
}